module.exports = __webpack_public_path__ + "static/media/couple-stone.54c3effa.svg";